export enum LocationType {
  InPerson = 1,
  Phone = 2,
  Zoom = 3,
  GoogleMeet = 4,
  AskInvitee = 5,
  Teams = 6,
  Custom = 99,
}

export enum LocationTypeText {
  InPerson = 'inPerson',
  Phone = 'phone',
  Zoom = 'zoom',
  GoogleMeet = 'googleMeet',
  AskInvitee = 'askInvitee',
  Teams = 'teams',
  Custom = 'custom',
}

export const defaultSort = [
  LocationType.InPerson,
  LocationType.Zoom,
  LocationType.GoogleMeet,
  LocationType.Teams,
  // LocationType.AskInvitee,
  LocationType.Phone,
  LocationType.Custom,
];
